import { Button, Layout, Space, theme } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import LeftBackIcon from "../../../assets/icons/LeftBackIcon";
import SidebarBashIcon from "../../../assets/icons/SidebarBashIcon";
import ShebaLogo from "../../../assets/images/Sheba_Business_logo.svg";
import useModal from "../../../hooks/useModal";
import { SidebarLayoutProps } from "../../../layouts/SidebarLayout";
import AddInfoModalAfterLogin from "../../Auth/AddInfoModalAfterLogin";
import NotificationMenu from "./NotificationMenu";
import ProductsMenu from "./ProductsMenu";
import ProfileMenu from "./ProfileMenu";

interface SidebarContentProps extends SidebarLayoutProps {
  collapsed?: boolean;
  handleCollapsed: () => void;
  handleShowSidebar: () => void;
  isLogoTitle?: boolean;
  className?: string;
  isHide?: boolean;
  hideHeaderActions?: boolean;
}

export interface CheckedData {
  name?: string | null;
  gender?: string | null;
  department_id?: number;
  business_role_id?: number;
  joiningDate?: string | null;
}

export default function SidebarContent({
  handleShowSidebar,
  handleCollapsed,
  children,
  title,
  backLink,
  tabList,
  isLogoTitle,
  className,
  isHide,
  hideHeaderActions,
}: SidebarContentProps) {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const location = useLocation();
  const params = useParams();
  const { open, handleClose, handleOpen } = useModal<CheckedData>();
  const { user } = useAppSelector((state) => state.auth);

  return (
    <Layout>
      <div>
        <div
          className={`sticky !bg-white z-50 ${"top-0"}`}
          // className={`sticky !bg-white z-50 ${
          //   !user?.data?.email_verified ? "top-12" : "top-0"
          // }`}
        >
          <Header
            style={{
              padding: 0,
              background: colorBgContainer,
            }}
            className="h-20 border-b border-extra-light"
          >
            <div className="flex items-center max-h-full justify-between pr-5 h-full">
              <div className="flex items-center h-full pl-6">
                {!isHide && (
                  <div className="h-full flex justify-center items-center pl-0 pr-3">
                    <Button
                      type="text"
                      icon={<SidebarBashIcon />}
                      onClick={handleShowSidebar}
                      className="lg:hidden flex justify-center items-center"
                      size="small"
                    />
                    <Button
                      type="text"
                      icon={<SidebarBashIcon />}
                      onClick={handleCollapsed}
                      className="hidden lg:flex justify-center items-center"
                      size="small"
                    />
                  </div>
                )}

                {backLink && (
                  <Link to={backLink} className="flex items-center gap-2 pr-3">
                    <Button
                      type="text"
                      icon={<LeftBackIcon />}
                      onClick={handleCollapsed}
                      className="hidden lg:flex justify-center items-center !bg-[#f2f5ff] !rounded-full"
                      size="small"
                    />
                  </Link>
                )}

                {title && (
                  <h4 className="text-sub-header text-lg sm:text-[22px] font-semibold leading-[33px] mr-3">
                    {title}
                  </h4>
                )}

                {isLogoTitle && (
                  <div className="flex items-center gap-2">
                    <img
                      src={ShebaLogo}
                      alt="Sheba Logo"
                      className="w-20 h-14 object-contain"
                    />
                  </div>
                )}
                {/* 
                <Button
                  className="hidden md:flex outline-button-primary"
                  icon={<FeedbackIcon />}
                  size="small"
                >
                  Feedback
                </Button> */}
              </div>

              {!hideHeaderActions && (
                <div className="flex items-center gap-2 sm:gap-6">
                  <h3 className="font-medium text-[#5E718D] text-center text-sm">
                    Welcome! {user?.data?.name || user?.data?.username}
                  </h3>
                  <ProductsMenu />
                  <NotificationMenu />
                  <ProfileMenu />
                </div>
              )}
            </div>
          </Header>
          {tabList?.length ? (
            <Space
              size={16}
              align="center"
              className="w-full h-[46px] px-6 bg-white border-b border-extra-light"
            >
              {tabList.map((tab) => {
                // const currentPath = getSanitizedPathname(
                //   location.pathname,
                //   params
                // );
                // const isActive = currentPath.startsWith(tab.link);

                // const currentPath = location.pathname;
                // const isActive =
                //   currentPath === tab.link ||
                //   currentPath.startsWith(tab.link + "/");

                const currentPath = location.pathname;
                const isActive = currentPath === tab.link;

                return (
                  <Link
                    to={tab.link}
                    className={`px-1.5 text-base font-medium inline-block relative after:absolute after:w-full after:left-0 after:-bottom-3 cursor-pointer select-none ${
                      isActive
                        ? "!text-primary after:bg-primary after:h-0.5"
                        : "!text-body-text after:h-0"
                    }`}
                    key={tab.label}
                  >
                    {tab.label}
                  </Link>
                );
              })}
            </Space>
          ) : undefined}
        </div>

        <Content
          className={`p-6 bg-[#f7faff]
            ${"min-h-[calc(100vh-5rem)]"} ${className}`}
          /**
           ${
              !user?.data?.email_verified
                ? "min-h-[calc(100vh-8rem)]"
                : "min-h-[calc(100vh-5rem)]"
            }
           */
        >
          {/* if the login user does not have enough information, then open the modal */}
          {open?.type === "UPDATE" && (
            <AddInfoModalAfterLogin
              open={open.open}
              data={open.data}
              handleClose={handleClose}
              // handleOpen={handleOpen}
            />
          )}

          {children}
        </Content>
      </div>
    </Layout>
  );
}

function MenuIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H6C6.82843 1.5 7.5 2.17157 7.5 3V6C7.5 6.82843 6.82843 7.5 6 7.5H3C2.17157 7.5 1.5 6.82843 1.5 6V3Z"
        fill="#AFBACA"
      />
      <path
        d="M9 3C9 2.17157 9.67157 1.5 10.5 1.5H13.5C14.3284 1.5 15 2.17157 15 3V6C15 6.82843 14.3284 7.5 13.5 7.5H10.5C9.67157 7.5 9 6.82843 9 6V3Z"
        fill="#AFBACA"
      />
      <path
        d="M16.5 3C16.5 2.17157 17.1716 1.5 18 1.5H21C21.8284 1.5 22.5 2.17157 22.5 3V6C22.5 6.82843 21.8284 7.5 21 7.5H18C17.1716 7.5 16.5 6.82843 16.5 6V3Z"
        fill="#AFBACA"
      />
      <path
        d="M1.5 10.5C1.5 9.67157 2.17157 9 3 9H6C6.82843 9 7.5 9.67157 7.5 10.5V13.5C7.5 14.3284 6.82843 15 6 15H3C2.17157 15 1.5 14.3284 1.5 13.5V10.5Z"
        fill="#AFBACA"
      />
      <path
        d="M9 10.5C9 9.67157 9.67157 9 10.5 9H13.5C14.3284 9 15 9.67157 15 10.5V13.5C15 14.3284 14.3284 15 13.5 15H10.5C9.67157 15 9 14.3284 9 13.5V10.5Z"
        fill="#AFBACA"
      />
      <path
        d="M16.5 10.5C16.5 9.67157 17.1716 9 18 9H21C21.8284 9 22.5 9.67157 22.5 10.5V13.5C22.5 14.3284 21.8284 15 21 15H18C17.1716 15 16.5 14.3284 16.5 13.5V10.5Z"
        fill="#AFBACA"
      />
      <path
        d="M1.5 18C1.5 17.1716 2.17157 16.5 3 16.5H6C6.82843 16.5 7.5 17.1716 7.5 18V21C7.5 21.8284 6.82843 22.5 6 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V18Z"
        fill="#AFBACA"
      />
      <path
        d="M9 18C9 17.1716 9.67157 16.5 10.5 16.5H13.5C14.3284 16.5 15 17.1716 15 18V21C15 21.8284 14.3284 22.5 13.5 22.5H10.5C9.67157 22.5 9 21.8284 9 21V18Z"
        fill="#AFBACA"
      />
      <path
        d="M16.5 18C16.5 17.1716 17.1716 16.5 18 16.5H21C21.8284 16.5 22.5 17.1716 22.5 18V21C22.5 21.8284 21.8284 22.5 21 22.5H18C17.1716 22.5 16.5 21.8284 16.5 21V18Z"
        fill="#AFBACA"
      />
    </svg>
  );
}
